import { Controller } from "@hotwired/stimulus"
import { bandValuesToUncheck } from "@/lib/Listing/PriceBands"

export default class extends Controller {
  static targets = ["min", "max"]

  enforceBandExclusivity(event) {
    if (!event.target.checked) return

    const bands = [...this.element.querySelectorAll(".price-range-presets input[type='checkbox']")]
    const selectedValues = bands.filter((band) => band.checked).map((band) => band.value)
    const valuesToUncheck = bandValuesToUncheck(event.target.value, selectedValues)

    bands.forEach((band) => {
      if (band !== event.target && valuesToUncheck.includes(band.value)) band.checked = false
    })
  }

  clearRange() {
    if (this.hasMinTarget) this.minTarget.value = ""
    if (this.hasMaxTarget) this.maxTarget.value = ""
    this.element.querySelector("[data-controller='price-range-slider']")
      ?.dispatchEvent(new CustomEvent("price-range-slider:reset", { bubbles: true }))
  }
}
